import type { CmsApiTileGridBlockData } from '#/modules/cms/api/types/blocks/CmsApiTileGridBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';
import { dynamic } from '#/utils/dynamic';

export const CmsTileGridBlockMapping: CmsBlockMapping<CmsApiTileGridBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: dynamic(
      () =>
        import('./CmsTileGridBlock').then((m) => ({
          default: m.CmsTileGridBlock,
        })),
      { strategy: 'always' },
    ),
  };
